import { InjectionToken } from '@angular/core';

/**
 * Bridge to the AngularJS UI-Router `$state`.
 *
 * New Angular 18 components are downgraded into the AngularJS ui-router tree,
 * so there is no Angular `Router`/`ActivatedRoute`; the live route/query params
 * live on `$state.params` and navigation goes through `$state.go(...)`.
 *
 * UI-Router is the AngularJS shell's router with no Angular 18 equivalent in
 * this hybrid app, so — like UIB_MODAL_PORT — this port stays for the lifetime
 * of the AngularJS shell rather than being a temporary migration scaffold.
 *
 * Consumers: RouteParamsService (`params`, e.g. the Zendesk `return_to`) and
 * FeatureCustomersService (`go`, navigating after the order modal resolves).
 *
 * Reference: @uirouter/angularjs `$state` (apps/b2b-ui).
 */
export interface IStatePort {
  params: Record<string, string | null | undefined>;
  go(to: string, params?: Record<string, unknown>): unknown;
}

export const STATE_PORT = new InjectionToken<IStatePort>('STATE_PORT');
